<ng-template #modal>
  <ng-content></ng-content>
</ng-template>
